<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['select']);

const { t } = useI18n();
const dialogRef = ref(null);

const options = computed(() => [
  {
    key: 'article',
    icon: 'i-lucide-book-open',
    title: t('CAPTAIN.KNOWLEDGE.ADD_DIALOG.OPTIONS.ARTICLE.TITLE'),
    description: t('CAPTAIN.KNOWLEDGE.ADD_DIALOG.OPTIONS.ARTICLE.DESCRIPTION'),
  },
  {
    key: 'website',
    icon: 'i-lucide-globe-2',
    title: t('CAPTAIN.KNOWLEDGE.ADD_DIALOG.OPTIONS.WEBSITE.TITLE'),
    description: t('CAPTAIN.KNOWLEDGE.ADD_DIALOG.OPTIONS.WEBSITE.DESCRIPTION'),
  },
  {
    key: 'document',
    icon: 'i-lucide-paperclip',
    title: t('CAPTAIN.KNOWLEDGE.ADD_DIALOG.OPTIONS.DOCUMENT.TITLE'),
    description: t('CAPTAIN.KNOWLEDGE.ADD_DIALOG.OPTIONS.DOCUMENT.DESCRIPTION'),
  },
  {
    key: 'answer',
    icon: 'i-lucide-message-square-text',
    title: t('CAPTAIN.KNOWLEDGE.ADD_DIALOG.OPTIONS.ANSWER.TITLE'),
    description: t('CAPTAIN.KNOWLEDGE.ADD_DIALOG.OPTIONS.ANSWER.DESCRIPTION'),
  },
  {
    key: 'channel',
    icon: 'i-lucide-inbox',
    title: t('CAPTAIN.KNOWLEDGE.ADD_DIALOG.OPTIONS.CHANNEL.TITLE'),
    description: t('CAPTAIN.KNOWLEDGE.ADD_DIALOG.OPTIONS.CHANNEL.DESCRIPTION'),
  },
]);

const open = () => dialogRef.value?.open();
const selectOption = key => {
  dialogRef.value?.close();
  emit('select', key);
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="3xl"
    :title="$t('CAPTAIN.KNOWLEDGE.ADD_DIALOG.TITLE')"
    :description="$t('CAPTAIN.KNOWLEDGE.ADD_DIALOG.DESCRIPTION')"
    :show-cancel-button="false"
    :show-confirm-button="false"
  >
    <div class="grid gap-3 sm:grid-cols-2">
      <button
        v-for="option in options"
        :key="option.key"
        type="button"
        class="group flex min-h-28 items-start gap-4 rounded-lg border border-n-weak bg-n-solid-1 px-4 py-4 text-left hover:border-n-strong hover:bg-n-alpha-1"
        @click="selectOption(option.key)"
      >
        <span
          class="flex size-9 shrink-0 items-center justify-center rounded-lg bg-n-alpha-2 text-n-slate-11 group-hover:text-n-slate-12"
        >
          <span class="size-4" :class="option.icon" />
        </span>
        <span class="min-w-0">
          <span class="block text-sm font-semibold text-n-slate-12">
            {{ option.title }}
          </span>
          <span class="mt-1 block text-xs leading-5 text-n-slate-10">
            {{ option.description }}
          </span>
        </span>
      </button>
    </div>
    <template #footer />
  </Dialog>
</template>
